import React, { FormEvent, useState } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useHistory } from 'react-router-dom'

import Alert from 'util/modules/Alert'
import { img } from 'assets/online'
import { authenticate } from 'panel/user/redux/actions'
import { clearToken } from 'util/services/AuthService'

import './styles/SignOn.scss'

const REGISTER_URL = 'https://console.underchat.com.br/register'

const SignIn: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [isFetching, setFetching] = useState(false)
  const [form, setForm] = useState({ username: '', password: '' })

  async function handleForm (e: FormEvent): Promise<void> {
    e.preventDefault()
    setFetching(true)
    clearToken()

    await authenticate(form)(dispatch).then(res => {
      if (res?.status === 'success' && res?.data?.token) {
        const query = new URLSearchParams(history.location.search)
        history.push(query.get('to') || '/panel')
      }
    })

    setFetching(false)
  }

  return (
    <>
      <Alert />

      <div className="row sign-container">
        <div className="sign-content">
          <div className="row sign-title-box ">
            <img src={img.logo} alt="Logo" />
            <h2 className="text-center">Faca login para acessar o painel</h2>
            <p className="text-center"><i className="fa fa-shield-alt" />Ambiente seguro</p>
          </div>

          <form onSubmit={handleForm} className="row">
            <div className="form-control">
              <label>E-mail</label>
              <div className="row">
                <span className='icon-widget'>
                  <i className="fas fa-envelope" />
                </span>
                <input
                  className='flex'
                  type="text"
                  tabIndex={1}
                  value={form.username}
                  onChange={(e): void => setForm({ ...form, username: e.target.value })}
                  required={true}
                />
              </div>
            </div>

            <div className="form-control">
              <span className="row">
                <label className="flex">Senha</label>
                <NavLink tabIndex={4} to="/recovery" className="recovery-label">Esqueceu a senha?</NavLink>
              </span>
              <div className="row">
                <span className='icon-widget'>
                  <i className="fas fa-lock" />
                </span>
                <input
                  className='flex'
                  type="password"
                  tabIndex={2}
                  value={form.password}
                  onChange={(e): void => setForm({ ...form, password: e.target.value })}
                  required={true}
                />
              </div>
            </div>

            <div className="form-control">
              <button tabIndex={3} className="button button-entry col-12" disabled={isFetching}>
                {isFetching ? 'Fazendo login. Aguarde...' : 'Entrar'}
              </button>
            </div>
          </form>

          <p className="text-center underchat-copy-label margin-top-16 margin-bottom-8">
            Nao tem uma conta?&nbsp;
            <a
              style={{ color: 'var(--blue)' }}
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
            >
              Cadastre-se na nova versao
            </a>
          </p>
          <p className="text-center underchat-copy-label">
            (c) {(new Date()).getFullYear()} UnderChat. Desenvolvido com UnderChat
          </p>
        </div>
      </div>
    </>
  )
}

export default SignIn
